__turbopack_context__.v({
  "accordion": "faq-module-scss-module__jaR5JW__accordion",
  "accordionContent": "faq-module-scss-module__jaR5JW__accordionContent",
  "cta": "faq-module-scss-module__jaR5JW__cta",
  "faq": "faq-module-scss-module__jaR5JW__faq",
  "questions": "faq-module-scss-module__jaR5JW__questions",
  "title": "faq-module-scss-module__jaR5JW__title",
});
